<template>
  <modal
    ref="modal"
    :width="300"
    :height="400"
    :click-to-close="false"
    name="congrats-modal"
    class="congrats-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="closeCongratsModal">
      <span class="icon">
        <img
          src="~/assets/images/icons/Close-button.svg"
          class="icon alt"
          alt="close icon"
        />
      </span>
    </div>
    <div>
      <CongratsMessage
        :message="message"
        :description="description"
        :icon="icon"
      />
      <div v-if="buttonText && url" class="has-text-centered">
        <button class="button is-outlined" @click="continueToUrl">
          <span>
            {{ buttonText }}
          </span>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import CongratsMessage from '@/components/common/CongratsMessage'

export default {
  name: 'CongratsModal',
  components: { CongratsMessage },
  data() {
    return {
      buttonText: '',
      url: '',
      message: '',
      description: '',
      icon: [],
    }
  },
  computed: {},
  mounted() {},
  methods: {
    beforeOpen(event) {
      if (event.params) {
        const { buttonText, url, message, description, icon } = event.params
        this.buttonText = buttonText
        this.url = url
        this.message = message
        this.description = description
        this.icon = icon
      }
    },
    beforeClose(event) {
      this.$router.push(this.url)
    },
    continueToUrl() {
      this.$router.push(this.url)
      this.$modal.hide('congrats-modal')
    },
    closeCongratsModal() {
      this.$modal.hide('congrats-modal')
    },
  },
}
</script>

<style lang="scss">
.congrats-modal {
  .close-icon-container {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .v--modal-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    @include tablet {
      padding: 50px;
    }
  }
}
</style>
